import React from 'react'

import { SyntaxHighlighter } from './SyntaxHighlighter/SyntaxHighlighter'

const Code = ({
  className,
  language,
  content,
  theme = 'tomorrow',
  noMargin,
}) => {
  return content ? (
    <SyntaxHighlighter
      className={className}
      theme={theme}
      language={language}
      customStyle={{ margin: `${noMargin ? 0 : '35px'} 0` }}
    >
      {content}
    </SyntaxHighlighter>
  ) : null
}

export default Code
